module.exports = __webpack_public_path__ + "static/media/bus.dff2b323.gif";